import { render, staticRenderFns } from "./CardWeeds.vue?vue&type=template&id=3e821418&"
import script from "./CardWeeds.vue?vue&type=script&lang=js&"
export * from "./CardWeeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports